module.exports = __webpack_public_path__ + "assets/img/3027.fe56dc62.png";